import AllPodcastsTable from './AllPodcastsTable';

export default AllPodcastsTable;
